import ErrorPage, { ErrorType } from 'common/components/errorPages/ErrorPage';
import { Spinner } from 'common/components/loader/Spinner';
import { sanatizeNavigationUrl, useCompareUrlWithProjectId } from 'common/hooks/route';
import FullLayout from '../../../../Layouts/FullLayout';
import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, useParams } from 'react-router-dom';
import { PLANNING_ROUTES } from 'routes/routes.planning.const';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';

const FULL_SCREEN_ROUTES = [PLANNING_ROUTES.profileDetails];

const CalendarPage = lazy(() => import('modules/planning/pages/CalendarPage/CalendarPage'));
const EventDetailsPage = lazy(() => import('modules/planning/pages/EventDetails/EventDetailsPage'));
const AttendeesPage = lazy(() => import('modules/planning/pages/Atendees/AttendeesPage'));
const ProfilesPage = lazy(() => import('modules/planning/pages/Profiles/ProfilesPage'));
const ProfileDetailsPage = lazy(() => import('modules/planning/pages/Profiles/ProfileDetailsPage'));

function PlanningDynamicModule() {
  const { compareUrl } = useCompareUrlWithProjectId();
  const { projectId } = useParams();
  const { activeProject } = useModuleProjectContext();

  const renderPage = () => {
    switch (true) {
      case compareUrl(PLANNING_ROUTES.root):
        return (
          <Navigate
            to={sanatizeNavigationUrl({
              url: PLANNING_ROUTES.calendar,
              urlProjectId: projectId as string,
              activeProjectId: activeProject?.moduleProjectID as string,
            })}
            replace={true}
          />
        );
      case compareUrl(PLANNING_ROUTES.calendar):
        return <CalendarPage />;
      case compareUrl(PLANNING_ROUTES.profiles):
        return <ProfilesPage />;
      case compareUrl(PLANNING_ROUTES.profileDetails):
        return <ProfileDetailsPage />;
      case compareUrl(PLANNING_ROUTES.viewDetails):
        return <EventDetailsPage />;
      case compareUrl(PLANNING_ROUTES.attendees):
        return <AttendeesPage />;
      default:
        return <ErrorPage errorType={ErrorType.NOT_FOUND} />;
    }
  };

  if (compareUrl(FULL_SCREEN_ROUTES)) {
    return (
      <ErrorBoundary fallback={<ErrorPage />}>
        <Suspense fallback={<Spinner />}>{renderPage()}</Suspense>
      </ErrorBoundary>
    );
  }

  return (
    <FullLayout>
      <ErrorBoundary fallback={<ErrorPage />}>
        <Suspense fallback={<Spinner />}>{renderPage()}</Suspense>
      </ErrorBoundary>
    </FullLayout>
  );
}

export default PlanningDynamicModule;
